import { useEffect } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { Store } from 'store';
import getFlowStep from 'store/app/selector/getFlowStep';
import { nextStepFlowAction, registerFlowAction } from 'store/app/slice';
import { AvailableFlows } from 'store/app/types';

export type FlowStepCallback = (getState: () => Store, jumpNextStep: () => void) => void;

export interface OwnProps {
  flowId: AvailableFlows;
  flowSteps: FlowStepCallback[];
  onFlowEnd?: (store: () => Store) => void;
}

const Flow = ({ flowId, flowSteps, onFlowEnd }: OwnProps) => {
  const storeObj = useStore();

  const dispatch = useDispatch();
  const activeStep = useSelector((store: Store) => getFlowStep(store, flowId));

  const jumpNextStep = () => {
    dispatch(nextStepFlowAction(flowId));
  };

  useEffect(() => {
    dispatch(registerFlowAction(flowId));
  }, []);

  useEffect(() => {
    if (activeStep >= 0 && activeStep < flowSteps.length) {
      flowSteps[activeStep](storeObj.getState, jumpNextStep);
    }
    if (activeStep >= flowSteps.length) {
      onFlowEnd && onFlowEnd(storeObj.getState);
    }
  }, [activeStep]);

  return null;
};

export default Flow;
